import cls from 'classnames';
import { SearchBar } from 'antd-mobile';
import logo from '../../../assets/images/logo.png';
import searchIcon from '../../../assets/images/search-icon.png';
import menuUnfold from '../../../assets/images/menu_unfold.png';
import styles from './index.module.scss';
import { useState } from 'react';
export default (props: Record<string, any>) => {
  const [keyword, setKeyword] = useState<string>('');
  const { onSearch } = props;
  return (
    <div className={cls(styles['nav-content'], 'flex')}>
      <img src={menuUnfold} className={styles['nav-button']} />
      <div className={cls(styles['nav-center'], 'flex', 'flex1')}>
        <div className={styles['search-input-waper']}>
          <SearchBar
            onSearch={(val) => onSearch?.(val)}
            className={styles['nav-search']}
            onChange={(value) => setKeyword(value)}
          />
          <img src={searchIcon} className={styles['search-icon']} onClick={() => onSearch(keyword)} />
        </div>
      </div>
      <div className={styles['nav-logo']}>
        <img src={logo} />
      </div>
    </div>
  );
};
